// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1o4BS","overflowing":"ReadFullNote_overflowing__2G_pl"};